import { render, staticRenderFns } from "./DialogReset.vue?vue&type=template&id=2ec27a26"
import script from "./DialogReset.vue?vue&type=script&lang=js"
export * from "./DialogReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports